import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { endSession } from '../api/client/axios';
import { INSUFFICIENT_PERMISSION_MESSAGE } from '../permissions/constants';
import appConfig from '../config/appConfig';

export default function NoSubscriptionAccessPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleLogout = () => {
    queryClient.clear();
    endSession().finally(() => {
      navigate('/login', { replace: true });
    });
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        textAlign: 'center',
      }}
    >
      <Stack spacing={3} alignItems="center" maxWidth={480}>
        <img src={appConfig.brandLogoPath} alt={`${appConfig.brandName} logo`} width="120" />
        <Typography variant="h1">Insufficient permissions</Typography>
        <Typography color="text.secondary">{INSUFFICIENT_PERMISSION_MESSAGE}</Typography>
        <Button variant="contained" onClick={handleLogout}>
          Logout
        </Button>
      </Stack>
    </Box>
  );
}
